var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"loadComponent"}},[_c(_vm.computeNameComponent,{key:_vm.$route.name,tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }